{
  "REPORT": {
    "HEADER": "Conversaciones",
    "LOADING_CHART": "Cargando datos del gráfico...",
    "NO_ENOUGH_DATA": "No hemos recibido suficientes puntos de datos para generar el informe. Inténtalo de nuevo más tarde.",
    "DOWNLOAD_CONVERSATION_REPORTS": "Download conversation reports",
    "DATA_FETCHING_FAILED": "Error al obtener datos, por favor intente nuevamente.",
    "SUMMARY_FETCHING_FAILED": "No se pudo obtener el resumen, por favor inténtalo de nuevo más tarde.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversaciones",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensajes recibidos",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensajes enviados",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tiempo de primera respuesta",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "Tiempo de primera respuesta es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tiempo de resolución",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "El tiempo de resolución es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Recuento de traspasos",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Tiempo de espera del cliente",
        "TOOLTIP_TEXT": "El tiempo de espera es {metricValue} (basado en {conversationCount} conversaciones)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "Últimos 7 días",
      "LAST_14_DAYS": "Últimos 14 días",
      "LAST_30_DAYS": "Últimos 30 días",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "Últimos 3 meses",
      "LAST_6_MONTHS": "Últimos 6 meses",
      "LAST_YEAR": "Último año",
      "CUSTOM_DATE_RANGE": "Rango de fechas personalizado"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplicar",
      "PLACEHOLDER": "Seleccione rango de fechas"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Agrupar por",
    "DURATION_FILTER_LABEL": "Duración",
    "GROUPING_OPTIONS": {
      "DAY": "Día",
      "WEEK": "Semana",
      "MONTH": "Mes",
      "YEAR": "Año"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Día"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Día"
      },
      {
        "id": 2,
        "groupBy": "Semana"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Día"
      },
      {
        "id": 2,
        "groupBy": "Semana"
      },
      {
        "id": 3,
        "groupBy": "Mes"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "Semana"
      },
      {
        "id": 3,
        "groupBy": "Mes"
      },
      {
        "id": 4,
        "groupBy": "Mes"
      }
    ],
    "BUSINESS_HOURS": "Horarios",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Limpiar filtros",
      "EMPTY_LIST": "No se encontraron resultados"
    },
    "PAGINATION": {
      "RESULTS": "Mostrando {start} a {end} de {total} resultados",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Resumen de agentes",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "Cargando datos del gráfico...",
    "NO_ENOUGH_DATA": "No hemos recibido suficientes puntos de datos para generar el informe. Inténtalo de nuevo más tarde.",
    "DOWNLOAD_AGENT_REPORTS": "Descargar reportes de agente",
    "FILTER_DROPDOWN_LABEL": "Seleccionar agente",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Buscar agentes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversaciones",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensajes entrantes",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensajes salientes",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tiempo de primera respuesta",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "Tiempo de primera respuesta es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tiempo de resolución",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "El tiempo de resolución es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 días"
      },
      {
        "id": 1,
        "name": "Últimos 30 días"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último año"
      },
      {
        "id": 5,
        "name": "Rango de fechas personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplicar",
      "PLACEHOLDER": "Seleccione rango de fechas"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Resumen de etiquetas",
    "DESCRIPTION": "Track label performance with key metrics including conversations, response times, resolution times, and resolved cases. Click a label name for detailed insights.",
    "LOADING_CHART": "Cargando datos del gráfico...",
    "NO_ENOUGH_DATA": "No hemos recibido suficientes puntos de datos para generar el informe. Inténtalo de nuevo más tarde.",
    "DOWNLOAD_LABEL_REPORTS": "Descargar reportes de etiquetas",
    "FILTER_DROPDOWN_LABEL": "Seleecionar etiqueta",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "Buscar etiquetas"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversaciones",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensajes entrantes",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensajes salientes",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tiempo de primera respuesta",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "Tiempo de primera respuesta es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tiempo de resolución",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "El tiempo de resolución es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 días"
      },
      {
        "id": 1,
        "name": "Últimos 30 días"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último año"
      },
      {
        "id": 5,
        "name": "Rango de fechas personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplicar",
      "PLACEHOLDER": "Seleccione rango de fechas"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Resumen de bandeja de entrada",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Cargando datos del gráfico...",
    "NO_ENOUGH_DATA": "No hemos recibido suficientes puntos de datos para generar el informe. Inténtalo de nuevo más tarde.",
    "DOWNLOAD_INBOX_REPORTS": "Descargar reportes de bandeja de entrada",
    "FILTER_DROPDOWN_LABEL": "Seleccione una bandeja de entrada",
    "ALL_INBOXES": "All Inboxes",
    "SEARCH_INBOX": "Search Inbox",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversaciones",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensajes entrantes",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensajes salientes",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tiempo de primera respuesta",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "Tiempo de primera respuesta es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tiempo de resolución",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "El tiempo de resolución es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 días"
      },
      {
        "id": 1,
        "name": "Últimos 30 días"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último año"
      },
      {
        "id": 5,
        "name": "Rango de fechas personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplicar",
      "PLACEHOLDER": "Seleccione rango de fechas"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Vista general del equipo",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Cargando datos del gráfico...",
    "NO_ENOUGH_DATA": "No hemos recibido suficientes puntos de datos para generar el informe. Inténtalo de nuevo más tarde.",
    "DOWNLOAD_TEAM_REPORTS": "Descargar informes del equipo",
    "FILTER_DROPDOWN_LABEL": "Seleccionar equipo",
    "FILTERS": {
      "ADD_FILTER": "Añadir Filtro",
      "CLEAR_ALL": "Limpiar todo",
      "NO_FILTER": "No hay filtros disponibles",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "Buscar equipos"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversaciones",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensajes entrantes",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensajes salientes",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tiempo de primera respuesta",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "Tiempo de primera respuesta es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tiempo de resolución",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "El tiempo de resolución es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 días"
      },
      {
        "id": 1,
        "name": "Últimos 30 días"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último año"
      },
      {
        "id": 5,
        "name": "Rango de fechas personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplicar",
      "PLACEHOLDER": "Seleccione rango de fechas"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Reporte de encuestas de satisfacción",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "Descargar reportes CSAT",
    "DOWNLOAD_FAILED": "Error al descargar los informes CSAT",
    "FILTERS": {
      "ADD_FILTER": "Añadir Filtro",
      "CLEAR_ALL": "Limpiar todo",
      "NO_FILTER": "No hay filtros disponibles",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Buscar agentes",
        "INBOXES": "Search inboxes",
        "TEAMS": "Buscar equipos",
        "RATINGS": "Search ratings"
      },
      "AGENTS": {
        "LABEL": "Agente"
      },
      "INBOXES": {
        "LABEL": "Bandeja de entrada"
      },
      "TEAMS": {
        "LABEL": "Equipo"
      },
      "RATINGS": {
        "LABEL": "Calificación"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contacto",
        "AGENT_NAME": "Agente",
        "RATING": "Calificación",
        "FEEDBACK_TEXT": "Realimentacion de Comentario",
        "CONVERSATION": "Conversación",
        "CUSTOMER": "Customer",
        "RESPONSE": "Respuesta",
        "HANDLED_BY": "Handled by"
      },
      "UNKNOWN_CUSTOMER": "Unknown customer"
    },
    "NO_AGENT": "No assigned agent",
    "NO_FEEDBACK": "No feedback provided",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total de respuestas",
        "TOOLTIP": "Número total de respuestas recopiladas"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Puntuación de satisfacción",
        "TOOLTIP": "Número total de respuestas positivas / Número total de respuestas * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Tasa de respuesta",
        "TOOLTIP": "Número total de respuestas / Número total de mensajes de la encuesta de satisfacción enviados * 100"
      },
      "RATING_DISTRIBUTION": "Rating distribution"
    },
    "REVIEW_NOTES": {
      "TITLE": "Review notes",
      "PLACEHOLDER": "Add review notes about this rating...",
      "SAVE": "Guardar",
      "CANCEL": "Cancelar",
      "SAVING": "Guardando...",
      "SAVED": "Notes saved successfully",
      "SAVE_ERROR": "Failed to save notes",
      "UPDATED_BY": "Updated by {name} {time}",
      "UPDATED_BY_LABEL": "Updated by",
      "PAYWALL": {
        "TITLE": "Upgrade to add review notes",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "Actualizar ahora",
        "CANCEL_ANYTIME": "Puede cambiar o cancelar su plan en cualquier momento"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Informes de bot",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "Núm. de conversaciones",
        "TOOLTIP": "Número total de conversaciones manejadas por el bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total de respuestas",
        "TOOLTIP": "Número total de respuestas enviadas por el bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Tiempo de resolución",
        "TOOLTIP": "Número total de conversaciones resueltas por el bot / Número total de conversaciones manejadas por el bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Tasa de traspasos",
        "TOOLTIP": "Número total de conversaciones transmitidas a agentes / Número total de conversaciones manejadas por el bot * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Resumen",
    "LIVE": "En vivo",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Conversaciones abiertas",
      "LOADING_MESSAGE": "Cargando métricas de conversación...",
      "OPEN": "Abrir",
      "UNATTENDED": "Desatendido",
      "UNASSIGNED": "Sin asignar",
      "PENDING": "Pendientes"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Tráfico de Conversación",
      "NO_CONVERSATIONS": "No hay conversaciones",
      "CONVERSATION": "{count} conversación",
      "CONVERSATIONS": "{count} conversaciones",
      "DOWNLOAD_REPORT": "Descargar reporte"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Resolutions",
      "NO_CONVERSATIONS": "No hay conversaciones",
      "CONVERSATION": "{count} conversación",
      "CONVERSATIONS": "{count} conversaciones",
      "DOWNLOAD_REPORT": "Descargar reporte"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversaciones por agentes",
      "LOADING_MESSAGE": "Cargando métricas del agente...",
      "NO_AGENTS": "No hay conversaciones por agentes",
      "TABLE_HEADER": {
        "AGENT": "Agente",
        "OPEN": "Abrir",
        "UNATTENDED": "Desatendido",
        "STATUS": "Estado"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Equipo",
        "OPEN": "Abrir",
        "UNATTENDED": "Desatendido",
        "STATUS": "Estado"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Estado del agente",
      "ONLINE": "En línea",
      "BUSY": "Ocupado",
      "OFFLINE": "Fuera de línea"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Domingo",
    "MONDAY": "Lunes",
    "TUESDAY": "Martes",
    "WEDNESDAY": "Miércoles",
    "THURSDAY": "Jueves",
    "FRIDAY": "Viernes",
    "SATURDAY": "Sábado"
  },
  "SLA_REPORTS": {
    "HEADER": "Informes de SLA",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Cargando datos de SLA...",
    "DOWNLOAD_SLA_REPORTS": "Descargar reportes de SLA",
    "DOWNLOAD_FAILED": "Error al descargar los informes de SLA",
    "DROPDOWN": {
      "ADD_FIlTER": "Añadir Filtro",
      "CLEAR_ALL": "Limpiar todo",
      "CLEAR_FILTER": "Limpiar filtros",
      "EMPTY_LIST": "No se encontraron resultados",
      "NO_FILTER": "No hay filtros disponibles",
      "SEARCH": "Buscar filtro",
      "INPUT_PLACEHOLDER": {
        "SLA": "Nombre de SLA",
        "AGENTS": "Nombre del agente",
        "INBOXES": "Nombre de la bandeja de entrada",
        "LABELS": "Nombre de la etiqueta",
        "TEAMS": "Nombre del equipo"
      },
      "SLA": "Política de SLA",
      "INBOXES": "Bandeja de entrada",
      "AGENTS": "Agente",
      "LABELS": "Etiqueta",
      "TEAMS": "Equipo"
    },
    "WITH": "con",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Tasa de Aciertos",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Número de Fallos",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Número de conversaciones",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Política",
        "CONVERSATION": "Conversación",
        "AGENT": "Agente"
      },
      "VIEW_DETAILS": "Ver detalles"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "Bandeja de entrada",
    "AGENT": "Agente",
    "TEAM": "Equipo",
    "LABEL": "Etiqueta",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Número de resoluciones",
    "CONVERSATIONS": "Núm. de conversaciones"
  }
}
